import React,{useState, useEffect, useRef} from 'react';
import CompanyNameNumberSearch from '../CompanySearch/CompanyNameNumberSearch.js'
import HelpIcon from './HelpIcon';
import isEqual from 'lodash/isEqual';

const CompanySelect = ({
    control,
    name,
    companyName = '',
    companyNumber = '',
    label,
    errors,
    validation,
    align = 'left',
    sx = {},
    showRequiredIndicator = false,
    helptext,
    onChange
}) => {

    const [company_number, setCompanyNumber] = useState(companyNumber??'') // Initial company reg number
    const [company_name, setCompanyName] = useState(companyName??'') // Initial company Name
    const [refresh,setRefresh ] = useState(new Date().getTime())
    const [displaytext, setDisplayText] = useState('')
    const [registeredAddress, setRegisteredAddress] = useState({})
    
    const previousData = useRef();

    useEffect(()=> {
        if (!isEqual(previousData.current, {company_number, company_name})) {
            previousData.current = {company_number, company_name} ;
            onChange({ selectedvalue: company_number, text: company_name,registered_address: registeredAddress });
        }
    },[company_number, company_name, registeredAddress, onChange])

    const updateCompanyName = (e) => {
        console.log(e)
        const addr = {
            addr1:e?.registered_address?.address_line_1??"",
            addr2:e?.registered_address?.address_line_2??"",
            addr3:"",
            town: e?.registered_address?.locality??"",
            county: "",
            postcode: e?.registered_address?.postal_code??""
        }
        setRegisteredAddress(addr)
        setCompanyName(e.text)
        if((e.selectedvalue??"") > "" && e.selectedvalue === e.value) {
            if(company_number !== e.selectedvalue) {   
                setCompanyNumber(e.selectedvalue)
            }
        }
        //if(e.value !== null && company_number !== e.value && (e.selectedvalue??"") > "" && e.selectedvalue === e.value)
        setCompanyNumber(e.value)

        if((e.value??"") === "")
            setDisplayText(e.text??"")
        else
            setDisplayText(`${e.text??""} ${e.value?`( ${e.value})`:''}`)
        setRefresh(new Date().getTime())
        
    }




    return (
        <div className='form-row' >
        <div className="form-group" style={{ textAlign: align, width:'100%'}}>
            <label htmlFor='company_name'>
            Company Name / Number
            <HelpIcon helptext={helptext} />
            </label>

            <CompanyNameNumberSearch onChange={updateCompanyName}  value={company_number} text={company_name} displaytext={displaytext} refresh={refresh}/>
        </div>
        </div>
    )

}

export default CompanySelect;